import {
  ExecutiveActivity,
  ExecutiveAlert,
  ExecutiveKpi,
  ExecutiveQuickAction,
  ExecutiveStatus,
} from './dashboard.types';

export const executiveKpis: ExecutiveKpi[] = [
  {
    id: 'availability',
    label: 'Disponibilidade da plataforma',
    value: '99,98%',
    detail: 'Serviços corporativos monitorados',
    trend: '+0,03% no período',
    tone: 'positive',
  },
  {
    id: 'assets',
    label: 'Ativos catalogados',
    value: '248',
    detail: 'Componentes, sistemas e recursos',
    trend: '+18 novos ativos',
    tone: 'positive',
  },
  {
    id: 'operations',
    label: 'Operações em acompanhamento',
    value: '36',
    detail: 'Processos e ambientes operacionais',
    trend: '4 requerem atenção',
    tone: 'warning',
  },
  {
    id: 'events',
    label: 'Eventos críticos',
    value: '3',
    detail: 'Ocorrências abertas no período',
    trend: '-2 desde a última análise',
    tone: 'critical',
  },
];

export const executiveStatuses: ExecutiveStatus[] = [
  {
    id: 'iam',
    label: 'Identidade e acesso',
    value: 'Operacional',
    detail: 'Keycloak e autenticação OIDC ativos',
    tone: 'positive',
  },
  {
    id: 'catalog',
    label: 'Catálogo corporativo',
    value: 'Operacional',
    detail: 'Entidades e ownership disponíveis',
    tone: 'positive',
  },
  {
    id: 'observability',
    label: 'Observabilidade',
    value: 'Preparação',
    detail: 'Integração com Grafana prevista',
    tone: 'neutral',
  },
  {
    id: 'automation',
    label: 'Automação',
    value: 'Preparação',
    detail: 'Integração com n8n prevista',
    tone: 'neutral',
  },
];

export const executiveAlerts: ExecutiveAlert[] = [
  {
    id: 'alert-01',
    title: 'Revisão de ownership pendente',
    description: 'Quatro ativos corporativos aguardam confirmação de proprietário.',
    severity: 'media',
    timestamp: 'Hoje, 08:40',
  },
  {
    id: 'alert-02',
    title: 'Integração de métricas ainda não ativada',
    description: 'Os indicadores desta revisão utilizam dados estruturais demonstrativos.',
    severity: 'baixa',
    timestamp: 'Hoje, 08:15',
  },
  {
    id: 'alert-03',
    title: 'Política de acesso em revisão',
    description: 'Uma regra corporativa aguarda homologação administrativa.',
    severity: 'alta',
    timestamp: 'Ontem, 18:30',
  },
];

export const executiveActivities: ExecutiveActivity[] = [
  {
    id: 'activity-01',
    title: 'Baseline Visual v1.6 congelada',
    description: 'Shell, Header, Footer, Layout, Sidebar e Breadcrumb preservados.',
    timestamp: 'Hoje, 09:28',
  },
  {
    id: 'activity-02',
    title: 'Sidebar Corporativa homologada',
    description: 'Validação técnica concluída sem falhas ou alertas.',
    timestamp: 'Hoje, 09:08',
  },
  {
    id: 'activity-03',
    title: 'Catálogo corporativo atualizado',
    description: 'Novos ativos e grupos organizacionais foram registrados.',
    timestamp: 'Ontem, 17:20',
  },
];

export const executiveQuickActions: ExecutiveQuickAction[] = [
  {
    id: 'catalog',
    label: 'Abrir catálogo',
    description: 'Consultar ativos, sistemas e responsáveis.',
    href: '/catalog',
  },
  {
    id: 'templates',
    label: 'Criar componente',
    description: 'Iniciar um novo recurso pelos templates.',
    href: '/create',
  },
  {
    id: 'apis',
    label: 'Consultar APIs',
    description: 'Explorar contratos e documentação técnica.',
    href: '/api-docs',
  },
  {
    id: 'docs',
    label: 'Abrir TechDocs',
    description: 'Acessar documentação técnica publicada.',
    href: '/docs',
  },
];
